/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

import {
  Select,
  Spinner
} from '../'

import { decodeBase64 } from '../../utils'


class EmployerSelect extends React.PureComponent {
  static propTypes = {
    id: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    hasError: PropTypes.bool,
    placeholder: PropTypes.string,
    employerGroupId: PropTypes.string,
    className: PropTypes.string,
    data: PropTypes.object.isRequired
  }

  static defaultProps = {
    id: 'employerSelect',
    placeholder: 'Select employer'
  }

  render() {
    if (this.props.data.loading) {
      return <Spinner />
    }

    if (this.props.data.error) {
      return <div>Options not loaded</div>
    }

    return (
      <Select
        id={this.props.id}
        placeholder={this.props.placeholder}
        value={this.props.value}
        options={this.props.data.employers.edges.map(employer => (
          {
            value: employer.node.id,
            label: employer.node.friendlyName
          }
        ))}
        onChange={this.props.onChange}
        hasError={this.props.hasError}
        className={this.props.className}
      />
    )
  }
}

const getEmployers = gql`
  query($employerGroupId: UUID) {
    employers(employergroup_Id: $employerGroupId, orderBy: "friendly_name") {
      edges {
        node {
          id
          friendlyName
        }
      }
    }
  }
`

const withData = graphql(getEmployers, {
  options: ({ employerGroupId }) => ({
    variables: {
      employerGroupId: employerGroupId
        ? decodeBase64(employerGroupId)
        : undefined
      }
  })
})

export default withData(EmployerSelect)



// WEBPACK FOOTER //
// ./src/components/employer-select/index.js